exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more-link {\r\n  cursor: pointer;\r\n  color: black;\r\n}\r\n\r\n.more-link:hover {\r\n  color: red;\r\n}\r\n\r\n.project-list {\r\n  display: -ms-grid;\r\n  display: grid;\r\n  grid-gap: 20px;\r\n  -ms-grid-columns: 1fr 1fr;\r\n      grid-template-columns: 1fr 1fr\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/projects/projects.component.css
// module id = ../../../../../src/app/displayer/projects/projects.component.css
// module chunks = main